import { render, staticRenderFns } from "./InventoryManagement.vue?vue&type=template&id=9c192f16&scoped=true&"
import script from "./InventoryManagement.vue?vue&type=script&lang=js&"
export * from "./InventoryManagement.vue?vue&type=script&lang=js&"
import style0 from "./InventoryManagement.vue?vue&type=style&index=0&id=9c192f16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c192f16",
  null
  
)

export default component.exports